import { render, staticRenderFns } from "./TeamBioPopup.vue?vue&type=template&id=31b13bdb&"
import script from "./TeamBioPopup.vue?vue&type=script&lang=js&"
export * from "./TeamBioPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports